module.exports = fox._r("images/july4/gift-99.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/july4/gift-99.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/july4/gift-99.png
// module id = 300
// module chunks = 4